export default __webpack_public_path__ + "static/media/amenities.2e4bac9b.png";